import dayjs, { Dayjs } from '@seolens/date-manager';

const dayJS = (date: Date): Dayjs => dayjs(date);

export const parseDate = (date: Date): Dayjs => {
  return dayJS(date);
};

export const getTodayInTimeZone = (timeZone: string): Dayjs => dayjs.utc().tz(timeZone, false);

type Args = [
  sample:
    | '08:02'
    | '08/16/2018'
    | '08/16/2018 08:02'
    | 'August 16, 2018'
    | 'August 16, 2018 08:02'
    | 'Thursday, August 16'
    | 'Thursday, August 16, 2018'
    | 'Thursday, August 16, 2018 08:02'
    | 'Aug 16, 2018'
    | 'Aug 16, 2018 08:02'
    | 'Thu, Aug 16, 2018 08:02',
  withSeconds?: boolean,
];

export const getDateFactory = (date: Date, ...[...args]: Args): string => {
  const [sample, withSeconds = false] = args;

  let dateFormatString: string = '';

  if (sample === '08:02') {
    dateFormatString = 'HH:mm';
  } else if (sample === '08/16/2018') {
    dateFormatString = 'L';
  } else if (sample === '08/16/2018 08:02') {
    dateFormatString = 'L LT';
  } else if (sample === 'August 16, 2018') {
    dateFormatString = 'LL';
  } else if (sample === 'August 16, 2018 08:02') {
    dateFormatString = 'LLL';
  } else if (sample === 'Thursday, August 16, 2018 08:02') {
    dateFormatString = 'LLLL';
  } else if (sample === 'Thursday, August 16, 2018') {
    dateFormatString = 'dddd, MMMM D, YYYY';
  } else if (sample === 'Thursday, August 16') {
    dateFormatString = 'dddd, MMMM D';
  } else if (sample === 'Aug 16, 2018') {
    dateFormatString = 'll';
  } else if (sample === 'Aug 16, 2018 08:02') {
    dateFormatString = 'lll';
  } else if (sample === 'Thu, Aug 16, 2018 08:02') {
    dateFormatString = 'llll';
  }

  if (withSeconds) {
    dateFormatString = `${ dateFormatString }:ss`;
  }

  return dayJS(date).format(dateFormatString);
};
